module.exports = __webpack_public_path__ + "static/media/MacBook-Mockup.fa3cdea6.png";